// extracted by mini-css-extract-plugin
export var bImage = "ThreeCardsImage-module--bImage--7f998";
export var root = "ThreeCardsImage-module--root--ed412";
export var wrapperC = "ThreeCardsImage-module--wrapperC--4d40c";